import {AgeGrade, Maybe} from '../graphql/generated/types';
import {AGE_GRADE_TO_NUMBER_MAP} from './constant';
import {getIsNowOverAYear} from './getIsNowOverAYear';

export function getIsAgeRestricted({
  ageGrade,
  selfCensorship,
  age,
  authenticatedAt,
}: {
  ageGrade: AgeGrade;
  selfCensorship?: Maybe<boolean>;
  age?: Maybe<number>;
  authenticatedAt?: Maybe<string>;
}): boolean {
  const ageGradeNumber = AGE_GRADE_TO_NUMBER_MAP[ageGrade];
  // 19세 외는 제한 없음
  if (ageGradeNumber < 19) {
    return false;
  }
  if (selfCensorship) {
    return false;
  }
  if (!authenticatedAt) {
    return true;
  }
  if (!age || age < ageGradeNumber) {
    return true;
  }

  // 본인인증 1년 지난 경우를 체크합니다
  if (getIsNowOverAYear(authenticatedAt)) {
    return true;
  }
  return false;
}
